import request from "./request";
// 法治为民--地方性法规草案、政府规章草案列表
export function getPlaceGov(data) {
	return request({
	  url: "/userapi/fzwm/select_lfyjzj_list",
	  method: "post",
	  data: data
	});
}
// 法治为民--地方性法规草案、政府规章草案详情
export function getPlaceGovDetail(data) {
	return request({
	  url: "/userapi/fzwm/select_lfyjzj_one",
	  method: "post",
	  data: data
	});
}
// 法治为民--立法建议项目列表
export function getLawSuggest(data) {
	return request({
	  url: "/userapi/fzwm/select_lfjyxm_list",
	  method: "post",
	  data: data
	});
}
// 法治为民--立法建议项目--详情
export function getLawSuggestDetail(data) {
	return request({
	  url: "/userapi/fzwm/select_lfjyxm_one",
	  method: "post",
	  data: data
	});
}
// 法治为民--地方性法规草案、政府规章草案--章节列表
export function getZjlist(data) {
	return request({
	  url: "/userapi/fzwm/select_lfyjzj_zj_list",
	  method: "post",
	  data: data
	});
}
//法治为民--地方性法规草案、政府规章草案--提交
export function postPlaceGov(data) {
	return request({
	  url: "/userapi/fzwm/sub_lfyjzjca_zjfk",
	  method: "post",
	  data: data
	});
}
// 整体意见
export function postAll(data) {
	return request({
	  url: "/userapi/fzwm/sub_lfyjzjca_zhengtiyijian",
	  method: "post",
	  data: data
	});
}
// // 阅读全文
// export function redFullTxt(data) {
// 	return request({
// 	  url: "/userapi/fzwm/sub_lfyjzjca_zjfk",
// 	  method: "post",
// 	  data: data
// 	});
// }
// // 全文下载
// export function fullTxtDownload(data) {
// 	return request({
// 	  url: "/userapi/fzwm/sub_lfyjzjca_zjfk",
// 	  method: "post",
// 	  data: data
// 	});
// }
// 法治为民--立法建议项目--项目申报
export function postLaw(data) {
	return request({
	  url: "/userapi/fzwm/sub_lfjyxm_xmsbjl",
	  method: "post",
	  data: data
	});
}

// 执法--提交
export function postZF(data) {
	return request({
	  url: "/userapi/fzwm/sub_qzjy",
	  method: "post",
	  data: data
	});
}

// 司法--提交
export function postSF(data) {
	return request({
	  url: "/userapi/fzwm/sub_opinion",
	  method: "post",
	  data: data
	});
}
// 司法/守法--常见问题
export function getSFQuestion(data) {
	return request({
	  url: "/userapi/fzwm/select_frequently_problems",
	  method: "post",
	  data: data
	});
}
// 司法/守法--常见问题--详情
export function getSFQuestionDetail(data) {
	return request({
	  url: "/userapi/fzwm/select_frequently_problems_one",
	  method: "post",
	  data: data
	});
}
// 司法/守法--反馈公开
export function getSFFeed(data) {
	return request({
	  url: "/userapi/fzwm/select_opinion",
	  method: "post",
	  data: data
	});
}
// 司法/守法--反馈公开--详情
export function getSFFeedDetail(data) {
	return request({
	  url: "/userapi/fzwm/select_opinion_one",
	  method: "post",
	  data: data
	});
}
// 法治地图--我要查
export function getMapData(data) {
	return request({
	  url: "/userapi/fzwm/select_group_map",
	  method: "post",
	  data: data
	});
}
// 获取行政区
export function getXZQList(data) {
	return request({
	  url: "/pub/select_pcode_dict",
	  method: "post",
	  data: data
	});
}
// 法治地图
export function getMapPoint(data) {
	return request({
	  url: "/userapi/index/select_index_map",
	  method: "post",
	  data: data
	});
}
// 立法建议项目--提交申报
export function getSBDetail(data) {
	return request({
	  url: "/userapi/fzwm/select_lfjyxm_xmsbjl",
	  method: "post",
	  data: data
	});
}
// 整体意见--初始化查询意见
export function getSuggestDe(data) {
	return request({
	  url: "/userapi/fzwm/select_lfyjzjca_zhengtiyijian",
	  method: "post",
	  data: data
	});
}
// 获取法治地图的坐标
export function getAllCoord(data) {
	return request({
	  url: "/userapi/index/select_index_map_xzq_count",
	  method: "post",
	  data: data
	});
}